"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const method = 'novoVictoryPark1.annualizedYield';
exports.concentrationLimitPointerMethods = [
    {
        method,
        pointerImplementation: ({ concentrationReceivables, valueConfig, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration [valueConfig.type:${valueConfig.type}] in concentration limit ${method}`);
            (0, common_1.finleyAssert)(valueConfig.valueType === 'percentage', `unsupported concentration limit [valueConfig.valueType:${valueConfig.valueType}] in concentration limit ${method}`);
            const weightedAverageReceivables = concentrationReceivables.map((receivable) => {
                const { finleyReceivableId, concentrationLimitFields: { eligibleExposureLessConcentrationLimitKickouts, }, } = receivable;
                const weight = receivable.dynamicIntermediateFields.balanceIfActiveAndPledged;
                (0, common_1.finleyAssert)(typeof weight === 'number', `Invalid balanceIfActiveAndPledged for receivable ${finleyReceivableId} in concentration limit ${method}`);
                const value = receivable.dynamicIntermediateFields.yield;
                (0, common_1.finleyAssert)(typeof value === 'number', `Invalid receivable.dynamicIntermediateFields.yield: ${receivable.dynamicIntermediateFields.yield} for receivable ${finleyReceivableId} in concentration limit ${method}`);
                return {
                    finleyReceivableId,
                    value,
                    weight,
                    eligibleExposureLessConcentrationLimitKickouts,
                };
            });
            const output = (0, calc_agent_1.calculateWeightedAverageReceivableKickouts)({
                receivables: weightedAverageReceivables,
                concentrationLimit: valueConfig.limit,
                limitType: 'min',
                waConcentrationLimitSolver: 'greedy',
            });
            return output;
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map